import { cx } from "@emotion/css";
import type * as React from "react";
import * as styles from "./LegacyDataTableStyles";
type LegacyDataTableHeaderColumnProps = React.DetailedHTMLProps<React.TdHTMLAttributes<HTMLTableHeaderCellElement>, HTMLTableHeaderCellElement>;
export function LegacyDataTableHeaderColumn({ className, children, ...otherProps }: LegacyDataTableHeaderColumnProps): React.ReactElement {
    return (<th className={cx(styles.dataTableHeaderColumn, className)} {...otherProps}>
            {children}
        </th>);
}
